module.exports = __webpack_public_path__ + "static/media/hazardous.e240cae4.svg";